<template>
    <div class="oc-loading-spinner" v-class="size">
        <div class="bounce1" :style="{backgroundColor: color}"></div>
        <div class="bounce2" :style="{backgroundColor: color}"></div>
        <div class="bounce3" :style="{backgroundColor: color}"></div>
    </div>
</template>

<script>
export default {
    name: 'oc-spinner',
    props: {
        size: {
            type: String,
            default: 'normal',
            validator: function (value) {
                return ['normal', 'small', 'big'].indexOf(value) !== -1
            }
        },
        color: {
            type: String,
            default: '#602144'
        }
    }
}
</script>

<style scoped>
.oc-loading-spinner {
    margin: 0;
    text-align: center;
}

.oc-loading-spinner > div {
    width: 15px;
    height: 15px;
    background-color: #602144;
    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.oc-loading-spinner.small > div {
    width: 10px;
    height: 10px;
}

.oc-loading-spinner.big > div {
    width: 20px;
    height: 20px;
}

.oc-loading-spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}

.oc-loading-spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
    0%, 80%, 100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    } 40% {
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
    }
}
</style>
